import * as React from "react";
import * as ReactDOM from "react-dom";
import Commonnav from "@/layouts/commonnav/commonnav";
import { EnhanceWidget, fetchDataSource } from "@jdwork/jdwork-sdk";

import ZeusBanner from "@/widgets/zeus_banner";
import ZeusBannerData from "./data/zeus_banner/data";
import style from "./index.module.scss";
import "./index.scss";

import ZeusSolutionAbilityDetail2933 from "@/widgets/zeus_solution_ability_detail2933";
import ZeusSolutionAbilityDetail2933Data from "./data/zeus_solution_ability_detail2933/data";

class Home extends React.Component {
  dataSourceMap: Record<string, any>;
  constructor(props) {
    super(props);
    this.dataSourceMap = new Map();
  }
  componentDidMount() {
    this.dataSourceMap.size > 0 && fetchDataSource(this.dataSourceMap);
  }
  render() {
    const { dataSourceMap } = this;
    return (
      <Commonnav>
        <div className="jdw-container">
          <div className="jdw-row">
            <div className="jdw-column">
              <div className="jdw-widget" data-name="zeus_banner" data-version="2.0.1">
                <ZeusBanner {...ZeusBannerData} />
              </div>
            </div>
          </div>
        </div>

        <div className="jdw-container" style={{ backgroundColor: "#fafafa" }}>
          <div className="jdw-row">
            <div className="jdw-column">
              <div className="jdw-widget" data-name="zeus_solution_ability_detail" data-version="2.2.3">
                {/* <EnhanceWidget
                  config={{ ...ZeusSolutionAbilityDetail2933Data }}
                  dataSourceMap={dataSourceMap}
                  widget={ZeusSolutionAbilityDetail2933}
                /> */}

                <div className={`${style.app}`}>
                  <p>
                    由于JOS平台现有京东快递接口无法满足新的物流服务的对接，「京东快递」的对接已转移至京东物流开放平台，请您在京东物流开放平台对接「京东快递」，对接文档参照
                    <a href="https://cloud.jdl.com/#/open-business-document/access-guide/267/53375" target="__blank"> 京东快递接入文档</a>。
                  </p>
                  <p>
                    京东物流开放平台是京东物流服务一站式接入平台，100%覆盖JOS的物流接口能力。目前，京东快递的接口能力仅在物流开放平台更新，JOS平台已停止更新。此外，京东物流开放平台提供了专门针对物流服务的完善的答疑机制，切实的解决客户在对接过程中产生的问题，提升客户的对接效率和接入体验。
                    若您有任何疑问请在开放平台提交工单咨询，工单提交地址：https://cloud.jdl.com/admin/#/upgrade/work-order
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Commonnav>
    );
  }
}

ReactDOM.render(<Home />, document.getElementById("root"));
